import Header from "./components/Header.jsx";
import Showcase from "./components/Showcase.jsx";
import Footer from "./components/Footer.jsx";

function App() {
  return (
    <>
      <Header/>
      <Showcase/>
      <Footer/>
    </>
  );
}

export default App;
